import RCEAsync from './rich-content-editor-async';

export default RCEAsync;
